/**
 * classic 스킨 — 현재 antd 표준 스타일. 변화 없음(기본값).
 *
 * 【중요】 token, extraAlgorithm, componentDefaults 는 모두 undefined.
 * → Classic 선택 시 useTheme 합산 결과가 기존과 완전히 동일해야 한다(픽셀 회귀 0).
 */
import type { SkinDef } from './types'

export const classicSkin: SkinDef = {
  key: 'classic',
  label: '클래식',
  description: 'Ant Design 표준 스타일 (기본)',
  swatch: { bg: '#ffffff', fg: '#1677ff', accent: '#e6f4ff' }
}
